import SwitchDeviceMode from './switch-device-mode-view'
export default SwitchDeviceMode
